import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { FilaFuncionario } from 'src/app/models/filas/fila-funcionario';
import { Funcionario } from 'src/app/models/funcionario';
import { CarregandoService } from 'src/app/services/carregando.service';
import { FilaFuncionarioService } from 'src/app/services/filaFuncionario.service';
import { FuncionarioService } from 'src/app/services/funcionario.service';
import { NotificacaoService } from 'src/app/services/notificacao.service';

@Component({
  selector: 'app-fila-sel-operador-modal',
  templateUrl: './fila-sel-operador-modal.component.html',
  styleUrls: ['./fila-sel-operador-modal.component.scss']
})
export class FilaSelOperadorModalComponent implements OnInit {

  operadores: FilaFuncionario[] = [];
  operadorSelecionado;
  idFila;

  constructor(private dialogRef: MatDialogRef<FilaSelOperadorModalComponent>, @Inject(MAT_DIALOG_DATA) public data: any,
    private carregandoService: CarregandoService, private notificacaoService: NotificacaoService, private filaFuncionarioService: FilaFuncionarioService) {
    this.idFila = data.idFila;
  }

  ngOnInit() {
    this.buscarOperadores();
  }

  buscarOperadores() {
    this.carregandoService.mostra('buscarOperadores');
    this.filaFuncionarioService.consultarLista(this.idFila, false).subscribe(funcs => {
      this.operadores = funcs;
      this.carregandoService.esconde('buscarOperadores');
    }, (erro) => {
      this.carregandoService.esconde('buscarOperadores');
      this.notificacaoService.erro(erro);
    });
  }

  selecionarOperador() {
    if (this.operadorSelecionado) {
      this.dialogRef.close(this.operadorSelecionado);
    }
  }

}
